import * as React from "react";
const Address = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 36 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.9997 0.5C9.57342 0.5 2.72217 7.35125 2.72217 15.7775C2.72217 23.2675 15.0247 37.3462 17.9997 40.6362C20.9747 37.3462 33.2772 23.2675 33.2772 15.7775C33.2772 7.35125 26.4259 0.5 17.9997 0.5ZM17.9997 23.0925C13.9659 23.0925 10.6847 19.8112 10.6847 15.7775C10.6847 11.7437 13.9659 8.47125 17.9997 8.47125C22.0334 8.47125 25.3147 11.7525 25.3147 15.7775C25.3147 19.8025 22.0334 23.0925 17.9997 23.0925Z"
      fill={props.fill}
    />
    <path
      d="M17.9999 42.8066C17.7549 42.8066 17.5274 42.7103 17.3612 42.5353C17.0724 42.2291 13.9749 38.8953 10.5537 34.4766C4.30615 35.7803 0.149902 38.6241 0.149902 41.6253C0.149902 45.9041 8.3224 49.5178 17.9999 49.5178C27.6774 49.5178 35.8499 45.9041 35.8499 41.6253C35.8499 38.6241 31.6937 35.7803 25.4462 34.4766C22.0249 38.8953 18.9274 42.2291 18.6387 42.5353C18.4724 42.7103 18.2449 42.8066 17.9999 42.8066Z"
      fill={props.fill}
    />
  </svg>
);
export default Address;
